<template>
  <div>
    <h1 class="mt-0 mb-15 text-center bold-text">
      Get started with your free CapsimInbox Authoring Platform account.
    </h1>
    <h4 class="text-center">
      Already have an authoring account?
      <router-link :to="{ name: 'home' }" class="text-center">Sign In here.</router-link>
    </h4>
    <form>
      <div class="row">
        <div class="col-md-6">
          <base-input
            v-model="form.firstName"
            id="firstName"
            label="First name"
            :error="errors['firstName']"
            required
          />
        </div>
        <div class="col-md-6">
          <base-input
            v-model="form.lastName"
            id="lastName"
            label="Last name"
            :error="errors['lastName']"
            required
          />
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <base-input
            v-model="form.jobtitle"
            id="jobtitle"
            label="Job title"
            :error="errors['jobtitle']"
          />
        </div>
        <div class="col-md-6">
          <base-input
            v-model="form.phone"
            id="phone"
            label="Preferred phone"
            :error="errors['phone']"
          />
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <base-input
            v-model="form.company"
            id="company"
            label="Institution"
            :error="errors['company']"
            required
          />
        </div>
        <div class="col-md-6">
          <base-select
            v-model="form.companyType"
            id="company-type"
            label="Institution type"
            :error="errors['companyType']"
            :options="companyTypes"
            placeholder="Please select an institution type"
            required
          />
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <base-radio-group
            v-model="form.referredFrom"
            label="How did you find us?"
            :error="errors['referredFrom']"
            :options="referralSrcs"
            name="referred-from"
            required
          />
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <base-radio-group
            v-model="form.useCase"
            label="What are you looking to build?"
            :error="errors['useCase']"
            :options="useCases"
            name="use-case"
            :showOther="true"
            v-slot="{ option }"
          >
            <input
              type="text"
              class="form-control ml-10"
              v-model="otherUseCase"
              v-if="option === 'Other'"
            />
          </base-radio-group>
        </div>
      </div>

      <button @click.prevent="nextStep" class="btn btn-primary">Next</button>
    </form>
  </div>
</template>

<script>
  export default {
    props: {
      errors: {
        type: Object,
        default: () => ({}),
      },
    },
    data() {
      return {
        form: {
          firstName: '',
          lastName: '',
          phone: '',
          company: '',
          jobtitle: '',
          companyType: null,
          referredFrom: '',
          useCase: '',
        },
        otherUseCase: '',
        companyTypes: ['Academic', 'Corporate'],
        referralSrcs: ['Capsim User', 'Email', 'Referred', 'Search Engine', 'Webinar'],
        useCases: ['Training', 'Assessment', 'Class Assignment', 'Just Curious', 'Other'],
      };
    },
    methods: {
      validatePersonalInfo() {
        const errors = {};
        if (this.form.firstName.length < 2) errors['firstName'] = 'Please enter a valid first name';
        if (this.form.lastName.length < 2) errors['lastName'] = 'Please enter a valid last name';
        if (this.form.company.length === 0) errors['company'] = 'Please enter a valid company name';
        if (this.form.companyType === null) errors['companyType'] = 'Required field';
        if (!this.form.referredFrom) errors['referredFrom'] = 'Required field';

        return errors;
      },

      async nextStep() {
        await this.$emit('error', this.validatePersonalInfo());

        if (Object.keys(this.errors).length) return;

        const form =
          this.form.useCase === 'Other'
            ? {
                ...this.form,
                useCase: this.otherUseCase || 'Other',
              }
            : this.form;
        this.$emit('next', form);
      },
    },
  };
</script>
